import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Notifications from '../../../../services/notifications';
import WalletProp, {
  CRYPTO_FARM,
  CRYPTO_FARM_ORDER,
} from '../../proptype/walletProp';
import translate from '../../../../commonComponents/translate';

const fetchFarmTotals = async currency => {
  const url = '/api/analytics/wallet/f2pool/totals';
  const params = {};
  if (currency) params.currency = currency;
  const { data: response } = await axios.get(url, {
    params,
    headers: {
      'Accept-Version': '1.0.0',
      'X-Gamification-API': 'Games',
    },
  });

  return response.data;
};

function WalletCryptoFarmInfo(props) {
  const { t, wallet } = props;
  const { currency } = wallet || {};
  const [totals, setTotals] = useState({
    minersOnline: 0,
    hashrate: '0',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchFarmTotals(currency)
      .then(data => {
        setTotals(data);
        setLoading(false);
      })
      .catch(err => {
        Notifications.showErrorFromRequest(err);
        setLoading(false);
      });
  }, [currency]);

  // Convert totals object to array and sort based on CRYPTO_FARM_ORDER
  const totalsConverted = Object.entries(totals)
    .sort(([keyA], [keyB]) => CRYPTO_FARM_ORDER[keyA] - CRYPTO_FARM_ORDER[keyB])
    .map(([key, value]) => ({ [key]: value }));

  const renderValue = useCallback(
    (total, key, isLoading) => {
      let className = 'value ';
      let value = '';
      switch (key) {
        case CRYPTO_FARM.HASH_RATE:
          value = `${total[key] || 0} TH/s`;
          break;
        case CRYPTO_FARM.MINERS_ONLINE:
          className += `${total[key] && total[key] > 0 ? 'success' : 'danger'}`;
          value = total[key] && total[key] > 0 ? t('yes') : t('no');
          break;
        case CRYPTO_FARM.POWER_USAGE:
          value = `${total[key] || 0} Watt`;
          break;
        default:
          value = total[key] || 0;
          break;
      }
      return <div className={className}>{isLoading ? '' : value}</div>;
    },
    [totals, loading],
  );

  return (
    <div className="farm-info-container">
      <h5 className="subTitle">{`${currency} ${t('farm')}`}</h5>
      <div className="farm-info">
        {totalsConverted.map(total => {
          const key = Object.keys(total)[0];
          return (
            <div
              key={key}
              className={`container ${loading && 'm-loader m-loader--right '}`}
            >
              <span
                className={`label ${loading && 'loading-label-wrapper'}`}
              >{`${t(`commissions.walletType.crypto.${key}`)}:`}</span>
              {renderValue(total, key, loading)}
            </div>
          );
        })}
      </div>
    </div>
  );
}

WalletCryptoFarmInfo.propTypes = {
  t: PropTypes.func.isRequired,
  wallet: PropTypes.shape(WalletProp.propType),
};

WalletCryptoFarmInfo.defaultProps = {
  wallet: null,
};

export default translate(WalletCryptoFarmInfo);
